<template>
    <div>
        <div class="hours-grid">
            <div class="split-grid" v-if="availableDays.length">
                <div class="hours-column">
                    <div class="hours-row" v-for="day in days">
                        <div class="row-inner">
                            <p><strong>{{ day.recurs_on }}</strong></p>
                            <p v-if="!day.available">{{$t('components.unavailable')}}</p>
                            <template v-else>
                                <p v-if="day.schedule_time_start === '00:00' && day.schedule_time_end === '23:59'">{{$t('components.24-hours')}}</p>
                                <p v-else>{{ day.schedule_time_start | suffix }} - {{ day.schedule_time_end | suffix }}</p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="split-grid" v-else>
                <div class="hours-column">
                    <div class="hours-row" v-for="day in days">
                        <div class="row-inner">
                            <p><strong>{{ day.recurs_on }}</strong></p>
                            <p v-if="!day.available">{{$t('components.unavailable')}}</p>
                            <template v-else>
                                <p v-if="accessHours.all_hours_access">{{$t('components.24-hours')}}</p>
                                <p v-else>{{ accessHours.start | suffix }} - {{ accessHours.end | suffix }}</p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import chunk from 'lodash/chunk';
    import ListingRepository from '../../../repositories/ListingRepository';
    import ProcessAvailability from '../../mixins/ProcessAvailability';
    import moment from 'moment';

    export default {
        name: 'access-hours',

        mixins: [ProcessAvailability],

        props: {
            accessHours: {
                type: Object,
                default() {
                    return {};
                },
            },

            schedule: {
                type: String,
                default() {
                    return null;
                },
            },

            id: {
                type: String,
                default() {
                    return null;
                },
            },
        },

        filters: {
            suffix(val) {
                return moment(val, 'hh:mm').format('hh:mma');
            },
        },

        data() {
            return {
                errors: [],
                days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => {
                    return {
                        recurs_on: day,
                        schedule_time_end: '24:00',
                        schedule_time_start: '00:00',
                        available: true,
                    }
                }),
                availableDays: [],
                noRecurringDates: false,
            }
        },

        computed: {
            weekendsAvailable() {
                return this.schedule !== 'weekdays' && this.schedule !== 'allweek' && this.schedule !== 'intermittent';
            },

            weekdaysAvailable() {
                return this.schedule !== 'weekends' && this.schedule !== 'allweek' && this.schedule !== 'intermittent';
            },
        },

        mounted() {
            return ListingRepository.getRecurringAvailability(this.id)
                .then(({ data }) => {
                    this.processAvailability(data.data);
                }).catch(() => {
                    this.errors.push(this.$t('components.sorry-access-hours-for-this-space-could-not-be-obtained-at-this-time-please-try-again-later'));
                });
        },

        methods: {
            setUnavailableDays() {
                if (!this.weekendsAvailable) {
                    this.days.forEach((day) => {
                        if (day.recurs_on === 'saturday' || day.recurs_on === 'sunday') {
                            return day.available = false;
                        }
                    });
                }

                if (!this.weekdaysAvailable) {
                    this.days.forEach((day) => {
                        if (day.recurs_on === 'saturday' || day.recurs_on === 'sunday') {
                            return;
                        }

                        return day.available = false;
                    });
                }
            },
        },
    }
</script>
